import styled from 'styled-components'

export const StyledCommonModalState = styled.div`
  width: 360px;
  background: #2d3355;
  border-radius: 16px;
  padding-top: 30px;
  box-sizing: border-box;
  position: relative;

  @media screen and (max-width: 640px) {
    position: absolute;
    padding-top: 30px;
    width: 100%;
    top: auto;
    bottom: 0;
    left: 0 !important;
    right: 0 !important;
    border-radius: 6px 6px 0 0;
    transform: none;
    padding-bottom: calc(env(safe-area-inset-bottom));
  }
`

export const StyledTradeDetail = styled.div`
  background: #2d3355;
  border-radius: 16px;

  @media screen and (max-width: 1420px) {
    ${StyledCommonModalState} {
      right: 50%;
      transform: translate(50%, -50%);
    }
  }

  @media screen and (max-width: 640px) {
  }
`

export const StyledTradeDetailHeader = styled.div`
  padding: 25px 25px 0 25px;
`

export const StyledTradeDetailSection = styled.div`
  padding: 14px 25px;
  color: #fff;
  font-size: 12px;
  .countdown {
    display: flex;
    align-items: center;
    color: #76d134;
    img {
      display: block;
      width: 10px;
      height: 10px;
      margin-right: 6px;
    }
  }

  .modal-section-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 9px;
    &:last-child {
      margin-bottom: 0;
    }
    .fee-item-left {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  @media screen and (max-width: 640px) {
    border-color: #b6bacc;
  }
`

export const StyledTradeDetailTitle = styled.div`
  color: #fff;
  font-size: 12px;
  display: flex;
  margin-bottom: 10px;
  .modal-title-inner {
    font-weight: 600;
    font-size: 18px;
  }
`

export const StyledTradeDetailExchange = styled.div`
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  padding: 4px 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.5px dashed #8d93b5;
  word-break: break-all;
  .exchange-icon {
    width: 11px;
    height: 8px;
    display: block;
    margin: 0 11px;
    flex: 2;
  }
  .from-token {
    flex: 8;
    word-break: break-word;
  }
  .to-token {
    word-break: break-word;
    text-align: right;
  }
`

export const StyledTradeDetailLink = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 14px;
  .link {
    font-weight: 500;
    font-size: 13px;
    color: #b3a4ff;
  }
`

export const StyledTradeStatus = styled.div`
  background: #2d3355;
  border-radius: 16px;
  padding-bottom: 10px;

  &.instant {
    margin-top: 20px;
    background: rgba(250, 250, 252, 0.96);
  }

  .status-bar {
    padding: 10px 18px 0px;
    img {
      width: 100%;
    }

    &.instant {
      padding: 16px 9px 11px;
    }
  }
  .status-area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px 8px;
    .status-text {
      color: #8d93b5;
      font-size: 13px;
      width: 58px;
    }
    .packing {
      text-align: center;
    }
    .success {
      text-align: right;
    }
    .active-status {
      color: #b3a4ff;
      font-weight: 500;
    }

    &.instant {
      padding: 0 8px 12px;
      .status-text {
        color: #9598ab;
      }
      .active-status {
        color: #604dbc;
      }
    }
  }
  .status-tips {
    font-weight: 400;
    font-size: 13px;
    line-height: 13px;
    text-align: center;
    color: #604dbc;
  }
`

export const StyledTradeCountdown = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
